import { ListScripts } from "../Widgets/ListWidget/Lists/listScripts";
import moment from "moment";

export class PlannerScripts {
   static convertMsgRowToEvent = (row, columns) => {
      // Prepare start and end date
      const messageId = row[ListScripts.getLabelByTechname("id", columns)];
      const startDateString = row[ListScripts.getLabelByTechname("zajme", columns)];
      const startDate = startDateString ? startDateString.replaceAll(" ", "T") : null;
      const durationTimeString =
         row[ListScripts.getLabelByTechname("planned_work_time_min", columns)];
      const durationTime = durationTimeString ? +durationTimeString : 1;
      const endDate = startDateString
         ? moment(startDate, "YYYY-MM-DD HH:mm:ss")
              .add(durationTime, "minutes")
              .format("YYYY-MM-DDTHH:mm:ss")
         : null;
      // Return calendar event object
      const title = row[ListScripts.getLabelByTechname("temat", columns)];
      const privateTags = row[ListScripts.getLabelByTechname("private_tags", columns)];
      const lockedDataAndTime = row[ListScripts.getLabelByTechname("blocked", columns)];
      const lockDate = row[ListScripts.getLabelByTechname("blocked_date", columns)];
      const mhId = row[ListScripts.getLabelByTechname("id_mh", columns)];
      const mhMessageId = row[ListScripts.getLabelByTechname("id_message_mh", columns)];
      const mhTitle = row[ListScripts.getLabelByTechname("maintitle_mh", columns)];
      const mhSubtitle = row[ListScripts.getLabelByTechname("subtitle_mh", columns)];
      const mhKeyinfo = row[ListScripts.getLabelByTechname("keyinfo_mh", columns)];
      const mhSubinfo = row[ListScripts.getLabelByTechname("subinfo_mh", columns)];
      const mhLabel = row[ListScripts.getLabelByTechname("label_mh", columns)];
      const mhCalendar = row[ListScripts.getLabelByTechname("calendar_mh", columns)];
      const sender = row[ListScripts.getLabelByTechname("nadawca", columns)];
      const sendDate = row[ListScripts.getLabelByTechname("send_time", columns)];
      const priority = row[ListScripts.getLabelByTechname("Messages_priority_evz5l1", columns)];
      const deadline = row[ListScripts.getLabelByTechname("Messages_task_deadline_e355k5", columns)];
      const wasRead = row[ListScripts.getLabelByTechname("Messages_is_read_kc7fe9", columns)];
      const tags = row[ListScripts.getLabelByTechname("tagi", columns)];
      return {
         title,
         start: startDate,
         end: endDate,
         extendedProps: {
            messageId,
            tags,
            privateTags,
            lockedDataAndTime,
            lockDate,
            priority,
            deadline,
            wasRead,
            sender,
            sendDate,
            basicDuration: 60 // <- 1h in minutes, TODO -> put here the task estimation time in the future
         },
         allDay: false,
         overlap: true,
         editable: true,
         classNames: [`cal-event-${messageId}`],
         mhId,
         mhMessageId,
         mhTitle,
         mhSubtitle,
         mhKeyinfo,
         mhSubinfo,
         mhLabel,
         mhCalendar
      };
   };
   static prepareObjectToPlan = (
      eventObject,
      startDate,
      duration,
      lockDate = 0,
      lockedDataAndTime = 0
   ) => {
      return {
         Messages_id_rjcy1n: eventObject?.extendedProps?.messageId,
         Messages_subject_qxaw44: eventObject?.title,
         Messages_due_date_hye3j2: startDate,
         Messages_tags_f9p2fc: eventObject?.extendedProps?.tags,
         Messages_tags_private_pw86c5: eventObject?.extendedProps?.privateTags,
         Messages_content_ah5erh: "-", // TODO - future, content for new task created from email message
         Messages_task_to_finish_estimation_jnvcrb: duration,
         blocked_date: lockDate,
         blocked: lockedDataAndTime
      };
   };
}
